/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Language_DescriptionInputs */

const en_settings_language_description = /** @type {(inputs: Settings_Language_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose your preferred language`)
};

const es_settings_language_description = /** @type {(inputs: Settings_Language_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elige tu idioma preferido`)
};

/**
* | output |
* | --- |
* | "Choose your preferred language" |
*
* @param {Settings_Language_DescriptionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const settings_language_description = /** @type {((inputs?: Settings_Language_DescriptionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Language_DescriptionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_settings_language_description(inputs)
	return en_settings_language_description(inputs)
});